import { gql } from '@apollo/client';

export const CHECK_ECD_SERVICE = gql`
  mutation checkECDService($input: CheckECDOfficeInput!) {
    checkECDService: checkECDOfficeInstitutionBeforeUpserting(input: $input) {
      exists
      message
    }
  }
`;
